import { render, staticRenderFns } from "./molecule.ugc.zoomControl.vue?vue&type=template&id=56b2fe1a"
import script from "./molecule.ugc.zoomControl.vue?vue&type=script&lang=ts"
export * from "./molecule.ugc.zoomControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports